module.exports = __webpack_public_path__ + "img/shape-3.05b8cb9e.png";